export const careersQueryKeys = {
  all: ['careers'] as const,
  page: (slug: string) => [...careersQueryKeys.all, 'page', slug] as const,
};
